import {
  Award,
  CalendarDays,
  Camera,
  FileText,
  Home,
  Images,
  Info,
  Medal,
  Target,
  Trophy,
  UserPlus,
  Users,
} from "lucide-react";

export const navItems = [
  { href: "/", label: "Főoldal", icon: Home },
  { href: "/aktualis", label: "Aktuális", icon: CalendarDays },
  { href: "/versenyzoink", label: "Versenyzőink", icon: Medal },
  { href: "/media", label: "Média", icon: Images },
  { href: "/jelentkezes", label: "Jelentkezés", icon: UserPlus },
  { href: "/bemutatkozas", label: "Bemutatkozás", icon: Info },
  { href: "/tamogatok", label: "Támogatók", icon: Award },
  { href: "/palyazatok", label: "Pályázatok", icon: FileText },
];

export const latestResults = [
  {
    id: "result-szolnok-2026",
    date: "2026. szeptember",
    place: "Szolnok",
    title: "Kajak-kenu Felnőtt Magyar Bajnokság",
    lead: "Két sportoló, három táv, hat értékes eredmény a felnőtt mezőnyben.",
    results: [
      "Laczó Dániel — C1 5000 m, 4. hely",
      "Laczó Dániel — C1 1000 m, 7. hely",
      "Laczó Dániel — C1 500 m középfutam, 4. hely",
      "Ördögh Flóra — C1 5000 m, 8. hely",
      "Ördögh Flóra — C1 500 m és 1000 m, 9. hely",
    ],
    featured: true,
  },
  {
    id: "result-gyor-2026",
    date: "2026. augusztus 3–5.",
    place: "Győr",
    title: "Maraton világbajnoki válogató",
    lead: "Aranyérem és két világbajnoki kvalifikáció.",
    results: [
      "Ördögh Flóra — C1 női ifjúsági 10,6 km, 1. hely",
      "Laczó Dániel / Bakó Tamás — C2 férfi felnőtt 22,7 km, 2. hely",
      "Laczó Dániel — C1 férfi felnőtt rövidkör, 4. hely",
    ],
  },
  {
    id: "result-pitesti-2026",
    date: "2026. június 28.",
    place: "Pitești",
    title: "Maraton Európa-bajnokság",
    lead: "Nemzetközi élmezőnyben a magyar egység.",
    results: [
      "Laczó Dániel / Bakó Tamás — C2 férfi felnőtt 22 km, 4. hely",
    ],
  },
];

export const athletes = [
  {
    id: "athlete-laczo-daniel",
    initials: "LD",
    name: "Laczó Dániel",
    category: "C1 férfi felnőtt",
    focus: "síkvízi és maraton kenu",
    color: "blue" as const,
    highlights: [
      "Felnőtt Magyar Bajnokság — C1 5000 m, 4. hely",
      "Maraton EB — C2 22 km, 4. hely",
      "Maraton VB-válogató — C2 22,7 km, 2. hely",
    ],
  },
  {
    id: "athlete-ordogh-flora",
    initials: "ÖF",
    name: "Ördögh Flóra",
    category: "C1 női ifjúsági",
    focus: "síkvízi és maraton kenu",
    color: "red" as const,
    highlights: [
      "Maraton VB-válogató — C1 10,6 km, 1. hely",
      "Felnőtt Magyar Bajnokság — C1 5000 m, 8. hely",
      "Felnőtt Magyar Bajnokság — C1 500 m és 1000 m, 9. hely",
    ],
  },
  {
    id: "athlete-szankovics-szonja-izabella",
    initials: "SZI",
    name: "Szankovics Szonja Izabella",
    category: "C1 női ifjúsági",
    focus: "síkvízi kenu",
    color: "navy" as const,
    highlights: [
      "Vidék Bajnokság — C1 1000 m, 4. hely",
      "Vidék Bajnokság — C1 500 m, 6. hely",
      "Országos Bajnokság — C1 5000 m, 10. hely",
    ],
  },
];

export const values = [
  { icon: Target, title: "Mérhető fejlődés", text: "A munkát egyéni célok, követhető fejlődési mutatók és tudatos versenyfelkészítés vezérli." },
  { icon: Users, title: "Emberközpontú nevelés", text: "A sportteljesítmény mellett önállóságot, felelősséget és egymás tiszteletét építjük." },
  { icon: Trophy, title: "Versenyzői szemlélet", text: "A rajtvonalig elvégzett munka számít: kitartás, technika, taktika és tiszta küzdelem." },
  { icon: Camera, title: "Élő közösség", text: "Edzések, versenyek és közös élmények kötik össze sportolóinkat és családjaikat." },
];

export const organization = {
  officialName: "SZVTSZ Vízisport Szakosztály",
  shortName: "SZVTSZ VSE",
  established: "2022. március 22.",
  seat: "6723 Szeged, József Attila sgt. 138/A.",
  site: "6726 Szeged, Közép Kikötő sor 1.",
  taxNumber: "19342351-2-06",
};

export const mediaItems = [
  {
    id: "media-versenyhangulat",
    mediaType: "image",
    label: "Versenyhangulat",
    title: "A célvonal pillanatai",
    image: "/canoe-sprint-rio.jpg",
    alt: "Síkvízi kajakverseny több egységgel",
    credit: "Jonas de Carvalho / Wikimedia Commons",
    source: "https://commons.wikimedia.org/wiki/File:Rio_2016._Canoagem_de_velocidade-Canoe_sprint_(28860179530).jpg",
    license: "CC BY-SA 2.0",
    licenseUrl: "https://creativecommons.org/licenses/by-sa/2.0/",
  },
  {
    id: "media-csapathajo",
    mediaType: "image",
    label: "Csapathajó",
    title: "Egy ritmus, egy cél",
    image: "/canoe-team-rio.jpg",
    alt: "Női négyes kajakegység verseny közben",
    credit: "Jonas de Carvalho / Wikimedia Commons",
    source: "https://commons.wikimedia.org/wiki/File:Rio_2016._Canoagem_de_velocidade-Canoe_sprint_(29041846272).jpg",
    license: "CC BY-SA 2.0",
    licenseUrl: "https://creativecommons.org/licenses/by-sa/2.0/",
  },
  {
    id: "media-edzes",
    mediaType: "image",
    label: "Edzés",
    title: "Munka a vízen",
    image: "/kayak-training-unsplash.jpg",
    alt: "Kajakosok edzésre szállnak vízre egy tavon",
    credit: "Mark Ashford / Unsplash",
    source: "https://unsplash.com/photos/kayakers-paddle-on-a-calm-lake-surrounded-by-greenery-YVMnOCdnhvg",
    license: "Unsplash License",
    licenseUrl: "https://unsplash.com/license",
  },
] as const;

export const partners = [
  { id: "partner-mkksz", mark: "MKKSZ", name: "Magyar Kajak-Kenu Szövetség", role: "Szakmai szövetség és normatív támogató" },
  { id: "partner-sportfurdo", mark: "SS&F", name: "Szegedi Sport és Fürdők Kft.", role: "Sportszolgáltatási együttműködő partner" },
  { id: "partner-szvtsz", mark: "SZVTSZ", name: "Szegedi Vízimentő és Tűzoltó Szakszolgálat", role: "Fenntartó szervezet" },
] as const;

export const grants = [
  {
    id: "grant-mkksz-2026",
    badge: "2026 • Aktív program",
    title: "MKKSZ normatív támogatás",
    reference: "M/625-1/2026",
    goal: "A sportolók felkészülésének, edzéslehetőségeinek és versenyzésének támogatása, a szakmai munka stabil feltételeinek biztosítása.",
    areas: ["Sportolói felkészülés", "Edzés- és sportszolgáltatások", "Versenyeztetés szakmai feltételei"],
  },
] as const;

export const pageCopyDefaults = {
  home: {
    eyebrow: "Szegedi vízisport-műhely",
    title: "A következő rajt itt kezdődik.",
    description: "Kajak-kenu utánpótlás, versenysport és összetartó közösség a Tisza partján — tudatos munkával, mérhető fejlődéssel.",
    body: "",
  },
  aktualis: {
    eyebrow: "Hírek és eredmények",
    title: "A rajtvonaltól a célig",
    description: "Versenybeszámolók, friss eredmények és azok a pillanatok, amelyekért minden edzésen dolgozunk.",
    body: "",
  },
  versenyzoink: {
    eyebrow: "Eredményes sportolóink",
    title: "Teljesítmény mögött ember",
    description: "Versenyzőink eredményeiben ott van a mindennapi munka, a fegyelem, a bátorság és a csapat támogatása.",
    body: "",
  },
  media: {
    eyebrow: "Képek és videók",
    title: "Pillanatok a vízről",
    description: "Versenyek, edzések és közösségi események — képekben és mozgásban.",
    body: "",
  },
  jelentkezes: {
    eyebrow: "Új tagoknak",
    title: "Találkozzunk a vízparton",
    description: "A kajak-kenu egyszerre fejleszt erőt, állóképességet, egyensúlyt és kitartást. Az első lépés egy rövid ismerkedés és személyes egyeztetés.",
    body: "",
  },
  bemutatkozas: {
    eyebrow: "Bemutatkozás",
    title: "Szegedi műhely, hosszú távú szemlélet",
    description: "Utánpótlás-nevelés, versenysport és közösségépítés egy helyen — a Tisza adottságaira és a sport emberformáló erejére építve.",
    body: `Az ${organization.officialName} 2022. március 22-én alakult. Feladatunk a kajak-, kenu- és más vízisportok utánpótlásának nevelése, a versenysport támogatása, valamint a vízisport társadalmi értékének erősítése Szegeden és a Dél-Alföldön.\n\nOlyan országosan elismert, stabil és innovatív sportműhelyt építünk, ahol a teljesítmény és az emberi fejlődés egymást erősíti.`,
  },
  tamogatok: {
    eyebrow: "Támogatók és partnerek",
    title: "Egy hajóban evezünk",
    description: "Az eredmények mögött sportolók, edzők, családok és olyan partnerek állnak, akik hisznek a szegedi vízisport jövőjében.",
    body: "",
  },
  palyazatok: {
    eyebrow: "Pályázatok",
    title: "Forrásból lehetőség",
    description: "A támogatási programok célja, felhasználása és az általuk létrejövő szakmai eredmények áttekinthetően.",
    body: "",
  },
} as const;
